/* eslint-disable camelcase */
import React, { memo, useEffect, useMemo, useState, useCallback } from "react";
import dynamic from "next/dynamic";

import styles from "@styles/checkout/order.module.scss";
import { api } from "@utils/api";
// eslint-disable-next-line import/order
import CloseImg from "@imageWrapper/closeImg";
const ReceipientBlock = dynamic(() =>
  import("@components/checkout/blocks/deliverTo/subBlocks/receipientBlock")
);
const AddEditAddress = dynamic(() =>
  import("@components/checkout/blocks/deliverTo/subBlocks/AddEditAddress")
);

import Loading from "@components/Loading";
const Deliverto = (props) => {
  const {
    callBackChangeAddress,
    selectedAddress,
    addressLoading,
    session,
    user,
    isGuest = false,
  } = props;
  const [data, setData] = useState({
    addressesList: [],
    showAddressAddEdit: false,
    selectedAddress: {},
    edit: false,
    addressLoader: false,
    addressEmpty: false,
  });

  const getCustomerAddresses = useCallback(
    async (id = null) => {
      try {
        const addresses = await api(
          {
            url: `/user/address`,
            method: "get",
          },
          session
        );
        if (addresses?.status) {
          if (addresses?.data.length === 0) {
            setData((preState) => ({
              ...preState,
              addressesList: [],
              addressLoader: false,
              addressEmpty: true,
            }));
          } else {
            if (addresses.data.length > 1) {
              addresses.data.sort((a, b) => b.is_default - a.is_default);
            }
            if (id) {
              let address = addresses.data.find((add) => {
                return add._id === id;
              });
              callBackChangeAddress(address);
            } else {
              if (!data.isLoaded) callBackChangeAddress(addresses.data[0]);
            }
            setData((preState) => ({
              ...preState,
              addressesList: addresses.data,
              addressLoader: false,
              addressEmpty: false,
              isLoaded: true,
              showAddressAddEdit: false,
              edit: false,
            }));
          }
        }
      } catch (e) {
        setData((preState) => ({
          ...preState,
          addressesList: [],
          addressLoader: false,
          addressEmpty: false,
          isLoaded: true,
          showAddressAddEdit: false,
          edit: false,
        }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callBackChangeAddress, session]
  );

  useEffect(() => {
    if (session && user && user._id) getCustomerAddresses();
  }, [user, session, getCustomerAddresses]);

  const getAddressObject = (address) => {
    const guestData = isGuest
      ? JSON.parse(sessionStorage.getItem("guestCheckout"))
      : {};
    let obj = {
      first_name: address.first_name
        ? address.first_name
        : !isGuest
        ? `${user.firstname} ${user.lastname || ""}`
        : `${guestData.name} ${guestData.lname || ""}`,
      last_name: address?.last_name || "",
      address: address.address || "",
      address_1: address?.address_1 || "",
      postcode: address.postcode || "",
      Suburb: address.Suburb || "",
      state: address.state || "",
      phoneCode: address?.phoneCode
        ? address?.phoneCode
        : isGuest
        ? guestData.phoneCode
        : "+61",
      phonenumber: address?.phonenumber
        ? address?.phonenumber
        : isGuest
        ? guestData.phoneNumber
        : "",
      phoneCountry: address?.phoneCountry
        ? address?.phoneCountry
        : isGuest
        ? guestData.country
        : "AU",
      country: address?.country
        ? address?.country
        : isGuest
        ? guestData.country
        : "AU",
      State_name: address?.State_name
        ? address?.State_name
        : address?.stateName
        ? address?.stateName
        : "",
      stateName: address?.State_name
        ? address?.State_name
        : address?.stateName
        ? address?.stateName
        : "",
      countryName: address?.Country_Name
        ? address?.Country_Name
        : address?.countryName
        ? address?.countryName
        : "",
      Country_Name: address?.Country_Name
        ? address?.Country_Name
        : address?.countryName
        ? address?.countryName
        : "",

      save_address_as: address?.save_address_as || "Home",
      is_default: address?.is_default || false,
      user_id: !isGuest ? user._id : "",
      location: address?.location || {},
    };
    if (address._id) obj["_id"] = address._id;
    return obj;
  };

  const changeAddress = (value) => {
    setData((preState) => ({
      ...preState,
      selectedAddress: getAddressObject(selectedAddress),
      showAddressAddEdit: value,
      edit: true,
    }));
  };

  const addAddress = () => {
    setData((preState) => ({
      ...preState,
      selectedAddress: getAddressObject({}),
      showAddressAddEdit: true,
      edit: false,
    }));
  };

  const addressFormSubmit = async (selectedAddress) => {
    setData((preState) => ({
      ...preState,
      selectedAddress: selectedAddress,
      showAddressAddEdit: false,
      edit: false,
    }));
    callBackChangeAddress(selectedAddress);
  };

  useEffect(() => {
    setData((preState) => ({
      ...preState,
      selectedAddress: selectedAddress,
    }));
  }, [selectedAddress]);

  const receipient = useMemo(
    () => (
      <ReceipientBlock
        styles={styles}
        selectedAddress={data.selectedAddress}
        changeAddress={changeAddress}
        addAddress={addAddress}
        emptyAddress={
          data.selectedAddress &&
          Object.keys(data.selectedAddress).length &&
          data?.selectedAddress?.postcode
            ? false
            : true
        }
        user={user}
        isGuest={isGuest}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data.selectedAddress]
  );

  const addressBlock = useMemo(
    () => (
      <AddEditAddress
        styles={styles}
        selectedAddress={data.selectedAddress}
        setData={setData}
        getAddressObject={getAddressObject}
        callBackAddressSubmit={addressFormSubmit}
        session={session}
        isGuest={isGuest}
        user={user}
        isEdit={data.edit}
        addressesList={data.addressesList}
        getCustomerAddresses={getCustomerAddresses}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data.selectedAddress, data.edit, data.addressesList]
  );

  return (
    <div className={styles.deliverInfoBlock}>
      <div className={styles.destinationHd}>
        <h2>
          Deliver to
          {data.showAddressAddEdit && (
            <CloseImg click={() => changeAddress(false)} />
          )}
        </h2>
      </div>
      {addressLoading ? (
        <div className="pt-5 pb-5">
          <Loading.LineLoader />
        </div>
      ) : (
        <>
          {data.showAddressAddEdit
            ? addressBlock
            : data.selectedAddress && receipient}
        </>
      )}
      <hr className={`row ${styles.deliverInfoSeparator}`}></hr>
    </div>
  );
};

export default memo(Deliverto);
